import { render, staticRenderFns } from "./bottom-popup2.vue?vue&type=template&id=98c4f064&"
import script from "./bottom-popup2.vue?vue&type=script&lang=js&"
export * from "./bottom-popup2.vue?vue&type=script&lang=js&"
import style0 from "./bottom-popup2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports